import { Controller } from "stimulus";
import { openModal } from "../util/modal";

export default class extends Controller {
  static targets = ["loading", "edit", "customEdit", "content", "amount", "customAmount", "submitBtn"];

  connect() {
    setTimeout(() => {
      const element = document.querySelector(".alert-danger");

      if (window.location.href.includes("/product_calculations/new") && element) {
        let opacity = 1;

        const animate = () => {
          opacity -= 0.02;
          if (opacity <= 0) {
            element.style.display = "none";
          } else {
            element.style.opacity = opacity;
            requestAnimationFrame(animate);
          }
        };

        requestAnimationFrame(animate);
      }
    }, 5000);
  }

  onAmountChanged(e) {
    this.toggleCustomEdit(!e.target.value);
    this.validateCustomAmount();
  }

  onCustomAmountChanged() {
    this.validateCustomAmount();
  }

  onSubmit() {
    this.showLoading();
    this.hideEdit();
  }

  onSuccess(e) {
    const [, , xhr] = e.detail;
    this.hideLoading();
    this.setContent(xhr.response);
  }

  onError() {
    // let [, , xhr] = e.detail;
    // alert(xhr.responseText);
    this.hideLoading();
    this.showEdit();
  }

  validateCustomAmount() {
    const valid = this.customAmountTarget.value.trim() !== ""
      && this.customAmountTarget.value >= 3000
      && this.customAmountTarget.checkValidity();

    this.customAmountTarget.classList.toggle("is-invalid", !valid);
    this.submitBtnTarget.disabled = !this.amount && !valid;
  }

  toggleCustomEdit(show) {
    if (show) {
      this.customAmountTarget.disabled = false;
      this.customEditTarget.classList.remove("d-none");
    } else {
      this.customAmountTarget.disabled = true;
      this.customEditTarget.classList.add("d-none");
    }
  }

  showLoading() {
    this.contentTarget.classList.add("d-none");
    this.loadingTarget.classList.remove("d-none");
  }

  hideLoading() {
    this.contentTarget.classList.remove("d-none");
    this.loadingTarget.classList.add("d-none");
  }

  setContent(content) {
    this.contentTarget.innerHTML = content;
  }

  showEdit() {
    this.editTarget.classList.remove("d-none");
    this.contentTarget.innerHTML = "";
  }

  hideEdit() {
    this.editTarget.classList.add("d-none");
  }

  onClickOpenProductModal(e) {
    e.preventDefault();

    openModal({
      url: e.currentTarget.href,
      modalClass: "modal-xl"
    });
  }

  get amount() {
    const checkedRadio = this.amountTargets.find(radio => radio.checked);
    return checkedRadio ? checkedRadio.value : null;
  }
}
